export default __webpack_public_path__ + "static/media/loginbg.df8f624c.png";